import React, { ReactElement, } from 'react'
import { Space, Input, Image, } from 'antd'
import Icon, { SearchOutlined, FullscreenOutlined } from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

// 熊猫图标
const PandaSvg = () => (
    <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
        <path
            d="M99.096 315.634s-82.58-64.032-82.58-132.13c0-66.064 33.032-165.162 148.646-148.646 83.37 11.91 99.096 165.162 99.096 165.162l-165.162 115.614zM924.906 315.634s82.58-64.032 82.58-132.13c0-66.064-33.032-165.162-148.646-148.646-83.37 11.91-99.096 165.162-99.096 165.162l165.162 115.614z"
            fill="#6B676E"
        />
        <path
            d="M1024 561.548c0 264.526-229.23 429.42-512.002 429.42S0 826.076 0 561.548 283.96 66.064 512.002 66.064 1024 297.022 1024 561.548z"
            fill="#FFEBD2"
        />
        <path
            d="M330.324 842.126c0 82.096 81.34 148.646 181.678 148.646s181.678-66.55 181.678-148.646H330.324z"
            fill="#E9D7C3"
        />
        <path
            d="M644.13 611.098C594.582 528.516 561.55 512 512.002 512c-49.548 0-82.58 16.516-132.13 99.096-42.488 70.814-78.73 211.264-49.548 247.742 66.064 82.58 165.162 33.032 181.678 33.032 16.516 0 115.614 49.548 181.678-33.032 29.18-36.476-7.064-176.93-49.55-247.74z"
            fill="#FFFFFF"
        />
        <path
            d="M611.098 495.484c0-45.608 36.974-82.58 82.58-82.58 49.548 0 198.194 99.098 198.194 165.162s-79.934 144.904-148.646 99.096c-49.548-33.032-132.128-148.646-132.128-181.678zM412.904 495.484c0-45.608-36.974-82.58-82.58-82.58-49.548 0-198.194 99.098-198.194 165.162s79.934 144.904 148.646 99.096c49.548-33.032 132.128-148.646 132.128-181.678z"
            fill="#6B676E"
        />
        <path
            d="M512.002 726.622c-30.06 0-115.614 5.668-115.614 33.032 0 49.638 105.484 85.24 115.614 82.58 10.128 2.66 115.614-32.944 115.614-82.58-0.002-27.366-85.556-33.032-115.614-33.032z"
            fill="#464655"
        />
        <path
            d="M330.324 495.484m-33.032 0a33.032 33.032 0 1 0 66.064 0 33.032 33.032 0 1 0-66.064 0Z"
            fill="#464655"
        />
        <path
            d="M693.678 495.484m-33.032 0a33.032 33.032 0 1 0 66.064 0 33.032 33.032 0 1 0-66.064 0Z"
            fill="#464655"
        />
    </svg>
)
const PandaIcon = (props: Partial<CustomIconComponentProps>) => (
    <Icon component={PandaSvg} {...props} />
)

// 机器人图标
export const ImgSrc = 'data:image/png;base64,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'

export const QAComp = (props: {
    winH: number
    width: number | string
    clickQuestion: () => void
}): ReactElement => {
    const { winH, width, clickQuestion } = props
    return (
        <div style={{ position: 'relative', width, height: winH - 130 }}>
            <div style={{ cursor: 'pointer' }}
                onClick={clickQuestion}
            ><FullscreenOutlined style={{ fontSize: 28, fontWeight: 'bold', color: '#2b5dde' }} /></div>
            <div style={{ height: winH - 210, overflowY: 'auto' }}>
                <Space direction='vertical' style={{ width: '100%' }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: 5, width: '100%' }}>
                        <div className='question'>
                        我想了解一點關於mask:1的相關資訊，請問有哪裡可以找到呢？
                        </div>
                        <PandaIcon style={{ fontSize: 25 }} />
                    </div>
                    <div style={{ display: 'flex', width: 'calc(100% - 30px)' }}>
                        <Image src={ImgSrc} width={50} preview={false} />
                        <div className='answer'>
                        在這裡可以找到mask:1相關的資訊。在這裡可以找到mask:1相關的資訊。在這裡。。。
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: 5, width: '100%' }}>
                        <div className='question'>
                        我想了解一點關於mask:1的相關資訊，請問有哪裡可以找到呢？
                        </div>
                        <PandaIcon style={{ fontSize: 25 }} />
                    </div>
                    <div style={{ display: 'flex', width: 'calc(100% - 30px)' }}>
                        <Image src={ImgSrc} width={50} preview={false} />
                        <div className='answer'>
                        在這裡可以找到mask:1相關的資訊。
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: 5, width: '100%' }}>
                        <div className='question'>
                        我想了解一點關於mask:1的相關資訊，請問有哪裡可以找到呢？
                        </div>
                        <PandaIcon style={{ fontSize: 25 }} />
                    </div>
                    <div style={{ display: 'flex', width: 'calc(100% - 30px)' }}>
                        <Image src={ImgSrc} width={50} preview={false} />
                        <div className='answer'>
                        在這裡可以找到mask:1相關的資訊。
                        </div>
                    </div>
                </Space>
            </div>
            <Input placeholder="Enter your question"
                suffix={<SearchOutlined style={{ fontSize: 20 }} />}
                className='question_input'
            />
        </div>
    )
}
